'use client';

import { ReactNode } from 'react';

import { Url } from 'next/dist/shared/lib/router/router';
import Link, { LinkProps } from 'next/link';
import { useSearchParams } from 'next/navigation';

export const LinkWithQueryParamsClient = ({
  ref,
  children,
  className,
  href,
  locale,
  ...props
}: {
  ref?: React.Ref<HTMLAnchorElement>;
  className?: string;
  children: ReactNode;
} & LinkProps) => {
  const params = useSearchParams();
  const currentQueryParams = Object.fromEntries(params?.entries() ?? []);

  const destinationQueryParams =
    typeof href === 'string'
      ? new URLSearchParams(href.split('?')[1])
      : typeof href.query === 'string'
      ? new URLSearchParams(href.query)
      : href.query;

  const mergedParams = {
    ...currentQueryParams,
    ...destinationQueryParams,
  };

  const [hrefWithoutHash, hash] = (
    (typeof href === 'string' ? href : href.pathname) ?? ''
  ).split('#');

  const customHref: Url =
    typeof href === 'string'
      ? {
          pathname: `${locale ? `/${locale}` : ''}${hrefWithoutHash}`,
          query: mergedParams,
          hash,
        }
      : { hash, ...href, query: mergedParams };

  return (
    <Link ref={ref} href={customHref} className={className} {...props}>
      {children}
    </Link>
  );
};
